/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnairsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Return air setpoint" |
*
* @param {Ahu_History_Key_Returnairsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnairsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Returnairsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnairsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air setpoint")
	return /** @type {LocalizedString} */ ("Consigne air reprise")
});
export { ahu_history_key_returnairsetpoint2 as "ahu_history_key_returnAirSetpoint" }